// extracted by mini-css-extract-plugin
module.exports = {"premium":"styles-m__premium__pxA-l","premium-icon":"styles-m__premium-icon__2YhtC","headline-premium-icon":"styles-m__headline-premium-icon__1NwCb"};